import { put, takeEvery } from "redux-saga/effects";
import HomePageEvents from "./HomePageEvents";
import HomePageApi from "./HomePageApi";

import { RecommendVideo, UserVideo, VerticalList } from "./model/HomePage";
import {
    GetRecVideoListComplete,
    // GetEditRecVideoListComplete,
    GetNewVideoList,
    GetNewVideoListComplete,
    GetRecommendProgramListComplete,
    GetRecommendProfessionalListComplete,
    AddVideoToRec,
    AddVideoToRecComplete,
    UpdateRecVideos,
    UpdateRecVideosComplete,
    UpdateRecVideosFailed,
    UpdateRecPrograms,
    UpdateRecProgramsComplete,
    UpdateRecProgramsFailed,
    UpdateRecProfessionals,
    UpdateRecProfessionalsComplete,
    UpdateRecProfessionalsFailed,
    GetVideoListByUserComplete,
    GetVideoListByUser,
    addRecProgram,
    addRecProgramComplete,
    delRecProgram,
    delRecProgramComplete,
    addRecProfessional,
    addRecProfessionalComplete,
    removeRecProfessional,
    removeRecProfessionalComplete,
    GetRecommendProgramList,
    GetRecVideoList,
    removeRecProfessionalFailed,
    GetRecommendProfessionalList,
} from "./HomePageActions";

// -----------------------------------------------------------------------------------
// おすすめビデオ
// 取得
function* GetRecommendVideo({ userId }: ReturnType<typeof GetRecVideoList>) {
    const videos: RecommendVideo[] = yield HomePageApi.GetRecommendVideoList(userId);
    yield put(GetRecVideoListComplete(videos));
}
// TODO
// function* GetEditRecommendVideo() {
//     const videos: RecommendVideo[] = yield HomePageApi.GetRecommendVideoList();
//     console.log("getEditRecommendVideoList", videos);
//     yield put(GetEditRecVideoListComplete(videos));
// }
// 編集（削除を含め）
function* UpdateRecVideoList({ videos, userId }: ReturnType<typeof UpdateRecVideos>) {
    const response: any = yield HomePageApi.UpdateRecVideos(videos, userId);
    if (response.response && response.response.status !== 200) {
        yield put(UpdateRecVideosFailed());
    } else {
        yield put(UpdateRecVideosComplete(response));
    }
}
// 追加
function* AddVideoToRecWorker({ videoId }: ReturnType<typeof AddVideoToRec>) {
    const recommendVideoList: RecommendVideo[] = yield HomePageApi.AddVideoToRec(videoId);
    yield put(AddVideoToRecComplete(recommendVideoList));
}

// -----------------------------------------------------------------------------------
// おすすめプログラム
// 取得
function* GetRecommendPrograms({ userId }: ReturnType<typeof GetRecommendProgramList>) {
    const recommendProgramList: VerticalList[] = yield HomePageApi.GetRecommendProgramList(userId);
    yield put(GetRecommendProgramListComplete(recommendProgramList));
}
// 編集
function* UpdateRecProgramList({ programs, userId }: ReturnType<typeof UpdateRecPrograms>) {
    const response: any = yield HomePageApi.UpdateRecPrograms(programs, userId);
    if (response.response && response.response.status !== 200) {
        yield put(UpdateRecProgramsFailed());
    } else {
        yield put(UpdateRecProgramsComplete(response));
    }
}
// 追加
function* addRecProgramWorker({ id, userId }: ReturnType<typeof addRecProgram>) {
    const response: any = yield HomePageApi.addRecProgram(id, userId);
    yield put(addRecProgramComplete(response));
}
// 削除
function* delRecProgramWorker({ id, userId }: ReturnType<typeof delRecProgram>) {
    const response: any = yield HomePageApi.delRecProgram(id, userId);
    yield put(delRecProgramComplete(response));
}

// -----------------------------------------------------------------------------------
// おすすめプロフェショナル
// 取得
function* GetRecommendProfessionalListWorker({
    userId,
}: ReturnType<typeof GetRecommendProfessionalList>) {
    const recommendProfessionalList: VerticalList[] =
        yield HomePageApi.GetRecommendProfessionalList(userId);
    yield put(GetRecommendProfessionalListComplete(recommendProfessionalList));
}
// 編集
function* UpdateRecProfessionalList({ professionals }: ReturnType<typeof UpdateRecProfessionals>) {
    const response: any = yield HomePageApi.UpdateRecProfessionals(professionals);
    if (response.response && response.response.status !== 200) {
        yield put(UpdateRecProfessionalsFailed());
    } else {
        yield put(UpdateRecProfessionalsComplete(response));
    }
}
// 追加
function* addRecProfessionalWorker({ id }: ReturnType<typeof addRecProfessional>) {
    const recommendProfessionalList: VerticalList[] = yield HomePageApi.addRecProfessional(id);
    yield put(addRecProfessionalComplete(recommendProfessionalList));
}
// 削除
function* removeRecProfessionalWorker({ id, userId }: ReturnType<typeof removeRecProfessional>) {
    const recommendProfessionalList: any = yield HomePageApi.removeRecProfessional(id);

    if (recommendProfessionalList.message) {
        const updateList: VerticalList[] = yield HomePageApi.GetRecommendProfessionalList(userId);
        yield put(removeRecProfessionalFailed(updateList));
    } else {
        yield put(removeRecProfessionalComplete(recommendProfessionalList));
    }
}
// -----------------------------------------------------------------------------------
// 新着ビデオ
// 取得
function* GetNewVideos({ userId }: ReturnType<typeof GetNewVideoList>) {
    const newVideoList: UserVideo[] = yield HomePageApi.GetNewVideoList(userId);
    yield put(GetNewVideoListComplete(newVideoList));
}

// -----------------------------------------------------------------------------------
// ユーザー視聴履歴
function* GetVideoList({ userId }: ReturnType<typeof GetVideoListByUser>) {
    const videoList: UserVideo[] = yield HomePageApi.GetVideosByUser(userId);
    yield put(GetVideoListByUserComplete(videoList));
}

export default function* HomePageSaga() {
    yield takeEvery(HomePageEvents.GetRecVideoListStarted, GetRecommendVideo);
    yield takeEvery(HomePageEvents.addRecProgramStarted, addRecProgramWorker);
    yield takeEvery(HomePageEvents.delRecProgramStarted, delRecProgramWorker);
    yield takeEvery(HomePageEvents.GetNewVideoListStarted, GetNewVideos);
    yield takeEvery(HomePageEvents.GetRecommendProgramListStarted, GetRecommendPrograms);
    yield takeEvery(
        HomePageEvents.GetRecommendProfessionalListStarted,
        GetRecommendProfessionalListWorker
    );
    yield takeEvery(HomePageEvents.AddVideoToRecStarted, AddVideoToRecWorker);
    yield takeEvery(HomePageEvents.UpdateRecVideosStarted, UpdateRecVideoList);
    yield takeEvery(HomePageEvents.UpdateRecProgramsStarted, UpdateRecProgramList);
    yield takeEvery(HomePageEvents.UpdateRecProfessionalsStarted, UpdateRecProfessionalList);
    yield takeEvery(HomePageEvents.GetVideoListByUserStarted, GetVideoList);
    yield takeEvery(HomePageEvents.addRecProfessionalStarted, addRecProfessionalWorker);
    yield takeEvery(HomePageEvents.removeRecProfessionalStarted, removeRecProfessionalWorker);
}
